import { STORAGE_APP_INSTALLED } from '@constants';

import { isWebkit, isX1 } from './Platform';

export const setStorageItem = (key, value) => {
  if (isX1 || isWebkit) {
    const date = new Date();
    const path = location.pathname;

    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toGMTString()}`;
    const cookie = `${key}=${encodeURIComponent(value)}; ${expires}; path=${path}`;

    document.cookie = cookie;
  } else {
    window.localStorage.setItem(key, value);
  }
};

export const getStorageItem = key => {
  if (isX1 || isWebkit) {
    const cookie = document.cookie.split('; ').find(cookieValue => cookieValue.startsWith(`${key}=`));

    return cookie === undefined ? null : decodeURIComponent(cookie.split('=')[1]);
  } else {
    return window.localStorage.getItem(key);
  }
};

// excludeAppInstalled as true by default will get the value of STORAGE_APP_INSTALLED
// and set the value again after clearing storage.
export const clearStorage = (excludeAppInstalled = true) => {
  let appInstalledValue = null;

  if (excludeAppInstalled) {
    // Get STORAGE_APP_INSTALLED before clear all the storage info
    appInstalledValue = getStorageItem(STORAGE_APP_INSTALLED);
  }

  if (isX1 || isWebkit) {
    const path = location.pathname;

    for (const c of document.cookie.split(';')) {
      document.cookie = c
        .replace(/^ +/, '')
        // eslint-disable-next-line no-div-regex
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=${path}`);
    }
  } else {
    window.localStorage.clear();
  }

  if (excludeAppInstalled && appInstalledValue) {
    // Set previous STORAGE_APP_INSTALLED info
    setStorageItem(STORAGE_APP_INSTALLED, appInstalledValue);
  }
};

export const getAllStorage = async () => {
  const cookieValues = {};

  if (isX1 || isWebkit) {
    for (const c of document.cookie.split('; ')) {
      const values = c.split('=');

      if (values.length >= 2) {
        cookieValues[values[0]] = decodeURIComponent(values[1]);
      }
    }
  } else {
    let index = 0;

    while (window.localStorage.key(index)) {
      const indexKey = window.localStorage.key(index);

      cookieValues[indexKey] = window.localStorage.getItem(indexKey);
      index++;
    }
  }

  return cookieValues;
};
